/* eslint-disable space-before-function-paren */
/* eslint-disable no-console */

export const createPlantDomMarker = (plant, plantMarkerHtml, popupBoxHtml, onClick, isSmallScreen) => {
  console.log('🏭 Creating plant marker for:', plant);
  const { lat, lng, plantNumber } = plant;

  if (!lat || !lng) {
    console.log('❌ Invalid plant coordinates:', { lat, lng });
    return null;
  }

  console.log('📍 Valid plant coordinates:', { lat, lng });
  const outerElement = document.createElement('div');
  outerElement.className = 'outer-element';
  outerElement.style.marginLeft = '-24px';
  outerElement.style.marginTop = '-24px';
  outerElement.setAttribute(`data-testid`, plantNumber);

  const plantMarkerElement = document.createElement('div');
  plantMarkerElement.innerHTML = plantMarkerHtml;
  plantMarkerElement.className = 'inner-element';

  const arrowElement = document.createElement('div');
  arrowElement.style.backgroundColor = '#fff';
  arrowElement.style.boxShadow = '0 0 4px #555';
  arrowElement.style.transform = 'rotateZ(45deg)';
  arrowElement.style.width = '15px';
  arrowElement.style.height = '15px';

  const arrowWrapperElement = document.createElement('div');
  arrowWrapperElement.style.position = 'absolute';
  arrowWrapperElement.style.top = '-8px';
  arrowWrapperElement.style.left = '17px';
  arrowWrapperElement.style.height = '10px';
  arrowWrapperElement.style.clip = 'rect(-10px,25px,8px,-6px)';

  const popupBoxElement = document.createElement('div');
  popupBoxElement.className = 'card-element';
  popupBoxElement.innerHTML = popupBoxHtml;
  popupBoxElement.style.position = 'absolute';
  popupBoxElement.style.top = '66px';
  popupBoxElement.style.left = '-1px';
  popupBoxElement.style.boxShadow = '0 0 4px #555';
  popupBoxElement.style.width = isSmallScreen ? '300px' : '400px';
  popupBoxElement.style.backgroundColor = '#fff';
  popupBoxElement.style.padding = '8px 16px';
  popupBoxElement.style.display = 'none';

  arrowWrapperElement.append(arrowElement);
  popupBoxElement.append(arrowWrapperElement);
  outerElement.append(popupBoxElement);
  outerElement.append(plantMarkerElement);

  if (isSmallScreen) {
    popupBoxElement.style.top = '66px';
    popupBoxElement.style.left = isSmallScreen ? '-123px' : '-178px';

    arrowWrapperElement.style.top = '-8px';
    arrowWrapperElement.style.left = isSmallScreen ? '140px' : '194px';
  }

  let popupInterval;
  const showCard = (e) => {
    if (popupInterval) return;
    const outerElement = e.currentTarget;
    // point to to actual DOM element
    const popupBoxElement = outerElement.querySelector('.card-element');
    if (popupBoxElement) {
      onClick({ lat, lng });
      popupInterval = setInterval(() => {
        window.document.addEventListener(isSmallScreen ? 'touchstart' : 'click', hideCard);
        popupBoxElement.style.display = 'block';
        popupBoxElement.parentElement.style.zIndex = '999';
      }, 500);
    }
  };

  const hideCardElements = () => {
    const allPopupBoxElements = window.document.querySelectorAll('.card-element');
    allPopupBoxElements.forEach((el) => {
      el.style.display = 'none';
      el.style.zIndex = '10';
      return el;
    });
  };

  const hideCard = (e) => {
    hideCardElements();
    clearInterval(popupInterval);
    popupInterval = null;
    // hide listener and add it only when popup is shown
    window.document.removeEventListener(isSmallScreen ? 'touchstart' : 'click', hideCard);
    e.stopPropagation();
  };

  const domIcon = new window.H.map.DomIcon(outerElement, {
    // the function is called every time marker enters the viewport
    onAttach: (clonedElement) => {
      clonedElement.addEventListener(isSmallScreen ? 'touchstart' : 'click', showCard);
    },
    // the function is called every time marker leaves the viewport
    onDetach: (clonedElement) => {
      clonedElement.removeEventListener(isSmallScreen ? 'touchstart' : 'click', showCard);
      window.document.removeEventListener(isSmallScreen ? 'touchstart' : 'click', hideCard);
    },
  });

  const marker = new H.map.DomMarker(
    {
      lat,
      lng,
    },
    {
      icon: domIcon,
    },
  );

  console.log('✅ Plant marker created successfully:', marker);
  return { marker, plant };
};
